import * as types from "./types";
import {
    getJobcardListAxios,
    deleteJobcardAxios,
    postJobcardAxios,
    putJobcardAxios,
    getJobcardIdAxios,
    getJobcardDemandAxios,
    putJobcardStatusAxios,
    putMultipleJobCard,
    getJobcardFileAxios,
    getJobcardPriorityAxios,
    postJobcardFileAxios,
    postMultipleJobcardFileAxios,
    deleteJobcardFileAxios,
    downloadJobcardDocument
} from "./services";


export async function postJobcardBatchTimesheetAction({ commit }, payload) {
    commit(types.JOBCARD_TIMESHEET_LOADING, true);
    try {
      const { data } = await postJobcardBatchTimesheetAxios(payload);
      commit(types.JOBCARD_ADD_TIMESHEET, data.result);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit(types.JOBCARD_TIMESHEET_LOADING, false);
    }
  }
  
export async function getJobcardPriorityListAction({commit}) {
    commit(types.LOADING_JOBCARD, true);
    try {
        const {data} = await getJobcardPriorityAxios();
        commit(types.GET_JOBCARD_PRIORITY, data);

    }
    catch(e) {
    
        throw e;
    }
  finally{
    commit(types.LOADING_JOBCARD, false);
  }
}

export async function updateJobcardAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        await putJobcardAxios(payload);
        commit(types.UPDATE_JOBCARD, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function getJobcardIdAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        const { data } = await getJobcardIdAxios(payload);
        commit(types.GET_JOBCARD_ID, data.result);
        return data.result;
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function getJobcardDemandAction({ commit }) {
    commit(types.LOADING_JOBCARD, true);
    try {
        const { data } = await getJobcardDemandAxios();
        commit(types.GET_JOBCARD_DEMAND, data.result.data);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function getJobcardFileAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        const { data } = await getJobcardFileAxios(payload);
        commit(types.GET_JOBCARD_FILES, data);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function getJobcardListAction({ commit }, status = null) {
    commit(types.LOADING_JOBCARD, true);
    try {
        const { data } = await getJobcardListAxios(status);
        commit(types.GET_JOBCARD_LIST, data.result.data);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }

}

export async function removeJobcardAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        await deleteJobcardAxios(payload);
        commit(types.REMOVE_JOBCARD, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function addJobcardAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        const { data } = await postJobcardAxios(payload);
        payload.id = data.id;
        payload.contactPersons = [];
        commit(types.ADD_JOBCARD, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function updateJobcardStatusAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        await putJobcardStatusAxios(payload);
        commit(types.UPDATE_JOBCARD_STATUS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function updateMultipleJobCardAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        await putMultipleJobCard(payload);
        commit(types.UPDATE_MULTIPLE_JOBCARD, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function addJobcardFileAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        const { data } = await postJobcardFileAxios(payload);
        commit(types.ADD_JOBCARD_FILE, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function addMultipleJobcardFileAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        const { data } = await postMultipleJobcardFileAxios(payload);
        commit(types.ADD_JOBCARD_FILE, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function removeJobcardFileAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        await deleteJobcardFileAxios(payload);
        commit(types.REMOVE_JOBCARD_FILE, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}

export async function downloadJobcardFileAction({ commit }, payload) {
    commit(types.LOADING_JOBCARD, true);
    try {
        const { data } = await downloadJobcardDocument(payload);
        commit(types.GET_JOBCARD_FILES_DOWNLOAD, data);
        return data;
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_JOBCARD, false);
    }
}